import { css } from '@emotion/react'
import styled from '@emotion/styled/macro'
import { Card } from 'components'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled(Card)`
  margin-bottom: ${theme.spacing.md};
`
export const QuotaWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const QuotaContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${theme.spacing['2xm']};

  @media (min-width: ${theme.breakpoints.lg}px) {
    gap: ${theme.spacing.lg};
  }
  flex-flow: row wrap;
`
type QuotaInfoContainerProps = {
  activated?: boolean
}

const quotaInfoModifiers = {
  success: () => css`
    & > span {
      color: ${theme.colors.alert.success.dark};
    }
    & > strong {
      color: ${theme.colors.alert.success.dark};
    }
  `,
  unavailable: () => css`
    & > span {
      color: ${theme.colors.neutral.mediumhover};
    }
    & > strong {
      color: ${theme.colors.neutral.mediumhover};
    }
  `,
}

export const QuotaInfoContainer = styled.div<QuotaInfoContainerProps>`
  width: fit-content;
  display: flex;
  flex-flow: column nowrap;
  gap: ${theme.spacing.xs};
  & > span {
    color: ${theme.colors.neutral.medium};
  }
  & > strong {
    color: ${theme.colors.neutral.high};
  }

  ${({ activated }) => activated && quotaInfoModifiers.success()}
  ${({ activated }) => activated !== undefined && !activated && quotaInfoModifiers.unavailable()}
`

export const QuotaTitle = styled.span`
  font-weight: ${theme.typography.weight.md};
  font-size: ${theme.typography.sizes['2xs']};
  line-height: ${theme.typography.lineHeight.md};
`

export const QuotaValue = styled.strong`
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.sm};
  line-height: ${theme.typography.lineHeight.md};

  text-transform: lowercase;
  &:first-letter {
    text-transform: capitalize;
  }
`

export const LevelValue = styled.span`
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.sm};
`

export const FactorySelect = styled.div`
  height: 44px;

  @media (max-width: ${theme.breakpoints.md}px) {
    margin-left: ${theme.spacing.sm};
  }

  border-radius: ${theme.shapes.borderRadius.md};
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  background: ${theme.colors.quartenary};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.sm};
`
export const FactoryLabel = styled.span`
  width: fit-content;
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  line-height: ${theme.typography.lineHeight.sm};
  color: ${theme.colors.neutral.high};
`

export const FactorySelectWrapper = styled.div`
  width: 100px;
`

export const StockCheckbox = styled.div`
  display: flex;
  align-items: center;

  span.MuiTypography-root {
    padding: 0 !important;
    font-size: ${theme.typography.sizes.xs} !important;
  }
`
